export default __webpack_public_path__ + "static/media/clients_all.86250c10.svg";